import React from 'react'

const IconReference = () => {
    return (
        <section className="wrapper">
            <style
                dangerouslySetInnerHTML={{
                    __html: `
            body,fieldset,input{font-family:sans-serif;margin:0;padding:0}.glyph,p{margin-bottom:1em}.glyph,.unit{float:left}.textbox0,input{height:1.5em;line-height:1.5}#testDrive,.textbox0,body,input{line-height:1.5}body{font-size:1em;color:#555;background:#fff}.bgc1,.textbox0{background:#f1f1f1}h1{font-size:1.5em;font-weight:400}small{font-size:.66666667em}a{color:#e74c3c;text-decoration:none}a:focus,a:hover{box-shadow:0 1px #e74c3c}.bshadow0,input{box-shadow:inset 0 -2px #e7e7e7}input:hover{box-shadow:inset 0 -2px #ccc}fieldset,input{font-size:1em;border:0}.fs0,.glyph{font-size:16px}input{color:inherit;padding:.25em 0}input:focus{outline:0;box-shadow:inset 0 -2px #449fdb}.glyph{width:15em;padding-bottom:1em;margin-right:4em;overflow:hidden}.liga{width:80%;width:calc(100% - 2.5em)}.talign-right{text-align:right}.talign-center{text-align:center}.fgc1{color:#999}.fgc0{color:#000}p{margin-top:1em}.mvm{margin-top:.75em;margin-bottom:.75em}.mtn{margin-top:0}.mal,.mtl{margin-top:1.5em}.mal,.mbl{margin-bottom:1.5em}.mal,.mhl{margin-left:1.5em;margin-right:1.5em}.mhmm{margin-left:1em;margin-right:1em}.mls{margin-left:.25em}.ptl{padding-top:1.5em}.pbs,.pvs{padding-bottom:.25em}.pts,.pvs{padding-top:.25em}.unitRight{float:right}.size1of2{width:50%}.size1of1{width:100%}.clearfix:after,.clearfix:before{content:" ";display:table}.clearfix:after{clear:both}.hidden-true{display:none}.textbox0{width:3em;padding:.25em .5em}#testDrive{display:block;padding-top:24px}.fs1{font-size:28px}
        `,
                }}
            />
            <div className="bgc1 clearfix">
                <h1 className="mhmm mvm">
                    <span className="fgc1">Font Name:</span> Liftone-Now{' '}
                    <small className="fgc1">(Glyphs:&nbsp;94)</small>
                </h1>
            </div>
            <div className="clearfix mhl ptl">
                <h1 className="mvm mtn fgc1">Grid Size: Unknown</h1>
                <div className="glyph fs1">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-planned_maintenance"></span>
                        <span className="mls"> icon-planned_maintenance</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e954"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe954;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs1">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-aerial_lift"></span>
                        <span className="mls"> icon-aerial_lift</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e953"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe953;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs1">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-other"></span>
                        <span className="mls"> icon-other</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e955"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe955;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs1">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-railcar_mover"></span>
                        <span className="mls"> icon-railcar_mover</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e956"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe956;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs1">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-trailer_spotter"></span>
                        <span className="mls"> icon-trailer_spotter</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e957"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe957;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs1">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-back"></span>
                        <span className="mls"> icon-back</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e94e"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe94e;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs1">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-filter"></span>
                        <span className="mls"> icon-filter</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e94f"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe94f;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs1">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-filter-outline"></span>
                        <span className="mls"> icon-filter-outline</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e950"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe950;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs1">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-clock"></span>
                        <span className="mls"> icon-clock</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e951"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe951;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs1">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-service"></span>
                        <span className="mls"> icon-service</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e952"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe952;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs1">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-forklift"></span>
                        <span className="mls"> icon-forklift</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e94d"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe94d;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs1">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-damaged-forklift"></span>
                        <span className="mls"> icon-damaged-forklift</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e958"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe958;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs1">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-data-plate"></span>
                        <span className="mls"> icon-data-plate</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e96b"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe96b;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs1">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-download1"></span>
                        <span className="mls"> icon-download1</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e970"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe970;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs1">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-filter-controls"></span>
                        <span className="mls"> icon-filter-controls</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e971"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe971;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs1">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-parts"></span>
                        <span className="mls"> icon-parts</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e972"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe972;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs1">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-qrcode-2"></span>
                        <span className="mls"> icon-qrcode-2</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e973"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe973;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
            </div>
            <div className="clearfix mhl ptl">
                <h1 className="mvm mtn fgc1">Grid Size: 16</h1>
                <div className="glyph fs2">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-qrcode"></span>
                        <span className="mls"> icon-qrcode</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e94c"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe94c;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
            </div>
            <div className="clearfix mhl ptl">
                <h1 className="mvm mtn fgc1">Grid Size: 24</h1>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-download"></span>
                        <span className="mls"> icon-download</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e900"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe900;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-inbox-download"></span>
                        <span className="mls"> icon-inbox-download</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e901"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe901;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-popin"></span>
                        <span className="mls"> icon-popin</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e902"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe902;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-popout"></span>
                        <span className="mls"> icon-popout</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e903"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe903;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-select-arrows"></span>
                        <span className="mls"> icon-select-arrows</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e904"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe904;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-d-caret"></span>
                        <span className="mls"> icon-el-icon-d-caret</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e904"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe904;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-triangle-down"></span>
                        <span className="mls"> icon-triangle-down</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e905"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe905;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-caret-bottom"></span>
                        <span className="mls"> icon-el-icon-caret-bottom</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e905"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe905;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-triangle-left"></span>
                        <span className="mls"> icon-triangle-left</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e906"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe906;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-caret-left"></span>
                        <span className="mls"> icon-el-icon-caret-left</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e906"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe906;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-triangle-right"></span>
                        <span className="mls"> icon-triangle-right</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e907"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe907;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-caret-right"></span>
                        <span className="mls"> icon-el-icon-caret-right</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e907"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe907;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-triangle-up"></span>
                        <span className="mls"> icon-triangle-up</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e908"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe908;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-caret-top"></span>
                        <span className="mls"> icon-el-icon-caret-top</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e908"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe908;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-upload"></span>
                        <span className="mls"> icon-upload</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e909"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe909;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-email"></span>
                        <span className="mls"> icon-email</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e90a"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe90a;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-message"></span>
                        <span className="mls"> icon-el-icon-message</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e90a"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe90a;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-login"></span>
                        <span className="mls"> icon-login</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e90b"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe90b;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-login-as"></span>
                        <span className="mls"> icon-login-as</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e90c"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe90c;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-logout"></span>
                        <span className="mls"> icon-logout</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e90d"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe90d;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-refresh"></span>
                        <span className="mls"> icon-refresh</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e90e"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe90e;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-refresh"></span>
                        <span className="mls"> icon-el-icon-refresh</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e90e"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe90e;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-search"></span>
                        <span className="mls"> icon-search</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e90f"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe90f;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-search"></span>
                        <span className="mls"> icon-el-icon-search</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e90f"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe90f;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-search-minus"></span>
                        <span className="mls"> icon-search-minus</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e910"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe910;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-zoom-out"></span>
                        <span className="mls"> icon-el-icon-zoom-out</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e910"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe910;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-search-plus"></span>
                        <span className="mls"> icon-search-plus</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e911"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe911;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-zoom-in"></span>
                        <span className="mls"> icon-el-icon-zoom-in</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e911"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe911;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-user"></span>
                        <span className="mls"> icon-user</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e912"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe912;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-close"></span>
                        <span className="mls"> icon-close</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e913"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe913;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-close"></span>
                        <span className="mls"> icon-el-icon-close</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e913"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe913;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-check"></span>
                        <span className="mls"> icon-check</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e914"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe914;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-check"></span>
                        <span className="mls"> icon-el-icon-check</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e914"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe914;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-location"></span>
                        <span className="mls"> icon-location</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e915"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe915;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs3">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-location"></span>
                        <span className="mls"> icon-el-icon-location</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e915"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe915;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
            </div>
            <div className="clearfix mhl ptl">
                <h1 className="mvm mtn fgc1">Grid Size: 14</h1>
                <div className="glyph fs4">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-cogs"></span>
                        <span className="mls"> icon-cogs</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e916"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe916;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs4">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-gears"></span>
                        <span className="mls"> icon-gears</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e916"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe916;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs4">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-cog"></span>
                        <span className="mls"> icon-cog</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e917"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe917;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs4">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-gear"></span>
                        <span className="mls"> icon-gear</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e917"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe917;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
            </div>
            <div className="clearfix mhl ptl">
                <h1 className="mvm mtn fgc1">Grid Size: 20</h1>
                <div className="glyph fs5">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-minus"></span>
                        <span className="mls"> icon-minus</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e918"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe918;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs5">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-minus"></span>
                        <span className="mls"> icon-el-icon-minus</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e918"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe918;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs5">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-plus"></span>
                        <span className="mls"> icon-plus</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e919"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe919;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs5">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-plus"></span>
                        <span className="mls"> icon-el-icon-plus</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e919"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe919;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs5">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-chevron-thin-up"></span>
                        <span className="mls"> icon-chevron-thin-up</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e91a"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe91a;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs5">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-arrow-up"></span>
                        <span className="mls"> icon-el-icon-arrow-up</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e91a"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe91a;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs5">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-chevron-thin-right"></span>
                        <span className="mls"> icon-chevron-thin-right</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e91b"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe91b;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs5">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-arrow-right"></span>
                        <span className="mls"> icon-el-icon-arrow-right</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e91b"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe91b;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs5">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-chevron-thin-left"></span>
                        <span className="mls"> icon-chevron-thin-left</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e91c"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe91c;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs5">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-arrow-left"></span>
                        <span className="mls"> icon-el-icon-arrow-left</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e91c"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe91c;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs5">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-chevron-thin-down"></span>
                        <span className="mls"> icon-chevron-thin-down</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e91d"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe91d;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs5">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-arrow-down"></span>
                        <span className="mls"> icon-el-icon-arrow-down</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e91d"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe91d;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
            </div>
            <div className="clearfix mhl ptl">
                <h1 className="mvm mtn fgc1">Grid Size: 32</h1>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-calendar"></span>
                        <span className="mls"> icon-calendar</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e91e"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe91e;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-date"></span>
                        <span className="mls"> icon-el-icon-date</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e91e"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe91e;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-calendar1"></span>
                        <span className="mls"> icon-calendar1</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e91f"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe91f;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-file"></span>
                        <span className="mls"> icon-file</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e920"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe920;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-file1"></span>
                        <span className="mls"> icon-file1</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e921"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe921;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-phone"></span>
                        <span className="mls"> icon-phone</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e922"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe922;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-mobile-phone"></span>
                        <span className="mls"> icon-el-icon-mobile-phone</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e922"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe922;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-camera"></span>
                        <span className="mls"> icon-camera</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e923"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe923;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-film"></span>
                        <span className="mls"> icon-film</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e924"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe924;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-microphone"></span>
                        <span className="mls"> icon-microphone</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e925"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe925;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-checkmark"></span>
                        <span className="mls"> icon-checkmark</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e926"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe926;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-success"></span>
                        <span className="mls"> icon-el-icon-success</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e926"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe926;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-cancel"></span>
                        <span className="mls"> icon-cancel</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e927"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe927;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-error"></span>
                        <span className="mls"> icon-el-icon-error</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e927"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe927;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-plus1"></span>
                        <span className="mls"> icon-plus1</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e928"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe928;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-minus1"></span>
                        <span className="mls"> icon-minus1</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e929"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe929;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-notice"></span>
                        <span className="mls"> icon-notice</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e92a"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe92a;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-warning"></span>
                        <span className="mls"> icon-el-icon-warning</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e92a"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe92a;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-picture"></span>
                        <span className="mls"> icon-picture</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e92b"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe92b;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-time"></span>
                        <span className="mls"> icon-time</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e92c"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe92c;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-time"></span>
                        <span className="mls"> icon-el-icon-time</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e92c"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe92c;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-eye"></span>
                        <span className="mls"> icon-eye</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e92d"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe92d;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-view"></span>
                        <span className="mls"> icon-el-icon-view</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e92d"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe92d;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-sitemap"></span>
                        <span className="mls"> icon-sitemap</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e92e"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe92e;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-chart"></span>
                        <span className="mls"> icon-chart</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e92f"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe92f;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-chart1"></span>
                        <span className="mls"> icon-chart1</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e930"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe930;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-chart2"></span>
                        <span className="mls"> icon-chart2</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e931"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe931;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-trashcan"></span>
                        <span className="mls"> icon-trashcan</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e932"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe932;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-delete"></span>
                        <span className="mls"> icon-el-icon-delete</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e932"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe932;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-lab"></span>
                        <span className="mls"> icon-lab</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e933"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe933;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-locked"></span>
                        <span className="mls"> icon-locked</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e934"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe934;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-unlocked"></span>
                        <span className="mls"> icon-unlocked</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e935"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe935;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-stack"></span>
                        <span className="mls"> icon-stack</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e936"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe936;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-stack1"></span>
                        <span className="mls"> icon-stack1</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e937"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe937;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-box"></span>
                        <span className="mls"> icon-box</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e938"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe938;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-grid"></span>
                        <span className="mls"> icon-grid</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e939"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe939;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-grid1"></span>
                        <span className="mls"> icon-grid1</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e93a"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe93a;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-menu"></span>
                        <span className="mls"> icon-el-icon-menu</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e93a"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe93a;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-list"></span>
                        <span className="mls"> icon-list</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e93b"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe93b;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-list1"></span>
                        <span className="mls"> icon-list1</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e93c"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe93c;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-tools"></span>
                        <span className="mls"> icon-tools</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e93d"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe93d;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-chat"></span>
                        <span className="mls"> icon-chat</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e93e"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe93e;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-attachment"></span>
                        <span className="mls"> icon-attachment</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e93f"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe93f;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-edit"></span>
                        <span className="mls"> icon-edit</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e940"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe940;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-edit"></span>
                        <span className="mls"> icon-el-icon-edit</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e940"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe940;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-heart"></span>
                        <span className="mls"> icon-heart</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e941"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe941;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-info"></span>
                        <span className="mls"> icon-info</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e942"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe942;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-info"></span>
                        <span className="mls"> icon-el-icon-info</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e942"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe942;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-paperplane"></span>
                        <span className="mls"> icon-paperplane</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e943"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe943;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-book"></span>
                        <span className="mls"> icon-book</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e944"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe944;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-printer"></span>
                        <span className="mls"> icon-printer</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e945"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe945;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-el-icon-printer"></span>
                        <span className="mls"> icon-el-icon-printer</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e945"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe945;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-pictures"></span>
                        <span className="mls"> icon-pictures</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e946"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe946;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-globe"></span>
                        <span className="mls"> icon-globe</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e947"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe947;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-shipping"></span>
                        <span className="mls"> icon-shipping</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e948"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe948;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-zip"></span>
                        <span className="mls"> icon-zip</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e949"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe949;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-zip1"></span>
                        <span className="mls"> icon-zip1</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e94a"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe94a;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
                <div className="glyph fs6">
                    <div className="clearfix bshadow0 pbs">
                        <span className="icon-tags"></span>
                        <span className="mls"> icon-tags</span>
                    </div>
                    <fieldset className="fs0 size1of1 clearfix hidden-false">
                        <input
                            type="text"
                            readOnly
                            value="e94b"
                            className="unit size1of2"
                        />
                        <input
                            type="text"
                            maxLength="1"
                            readOnly
                            value="&#xe94b;"
                            className="unitRight size1of2 talign-right"
                        />
                    </fieldset>
                    <div className="fs0 bshadow0 clearfix hidden-true">
                        <span className="unit pvs fgc1">liga: </span>
                        <input
                            type="text"
                            readOnly
                            value=""
                            className="liga unitRight"
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default IconReference
